import React from 'react'

import createCustomPropType from './createCustomPropType'

function childrenOfElement(expectedChildComponentName, props, propName, componentName) {
  const children = props[propName];
  React.Children.forEach(children, (child) => {
    const actualChildComponentName = child.type.displayName || child.type.name || child.type
    if (actualChildComponentName !== expectedChildComponentName) {
      throw new Error(`\`${componentName}\` only accepts children of type \`${expectedChildComponentName}\`. ${actualChildComponentName} was found`)
    }
  });
}

export default (expectedChildComponentName) => {
  const childrenOfElementBoundFn = childrenOfElement.bind(this, expectedChildComponentName)
  const childrenOfElementPropType = createCustomPropType(false, childrenOfElementBoundFn)
  childrenOfElementPropType.isRequired = createCustomPropType(true, childrenOfElementBoundFn)
  return childrenOfElementPropType
}
